import { render, staticRenderFns } from "./FiltroFalecidos.vue?vue&type=template&id=44fa02ee"
import script from "./FiltroFalecidos.vue?vue&type=script&lang=js"
export * from "./FiltroFalecidos.vue?vue&type=script&lang=js"
import style0 from "./FiltroFalecidos.vue?vue&type=style&index=0&id=44fa02ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports